import Enum from "../../../enums/Enum";

const DirectBillingItemAuthorizationStatusEnum = new Enum({
    PENDING: {name: "Pending"},
    APPROVED: {name: "Approved"},
    REJECTED: {name: "Rejected"},
    PARTIALLY_APPROVED: {name: "Partially Approved"},
    NOT_REQUIRED: {name: "Not Required"},
});

export default DirectBillingItemAuthorizationStatusEnum;